import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaCheck, FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";
import { GoEye, GoEyeClosed } from "react-icons/go";
import { ButtonLoader4 } from "../../components/ButtonLoader";

const ResetLink = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { uidb64, token } = useParams();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isCleaner, setIsCleaner] = useState(null);

  const navigate = useNavigate();

  // Password Validation Function
  const validatePassword = (password) => ({
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    // specialChar: /[@#%^&*]/.test(password),
    specialChar: /[!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~]/.test(password),
    noSpaces: !/\s/.test(password),
  });

  // const formik = useFormik({
  //   initialValues: {
  //     password: "",
  //   },
  //   validationSchema: Yup.object({
  //     password: Yup.string()
  //       .min(8, "Password must be at least 8 characters")
  //       .required("Password is required"),
  //   }),
  //   onSubmit: async (values) => {
  //     setLoading(true);
  //     try {
  //       const response = await axios.post(
  //         `${BASE_URL}/api/password-reset/complete/`,
  //         {
  //           uidb64,
  //           token,
  //           password: values.password,
  //         }
  //       );
  //       // Swal.fire({
  //       //   icon: "success",
  //       //   text: response.data.message || "Password Changed",
  //       //   customClass: {
  //       //     confirmButton: "custom-green-button",
  //       //   },
  //       // }).then(() => {
  //       //   navigate("/login");
  //       // });
  //       Swal.fire({
  //         icon: "success",
  //         text: response.data.message || "Password Changed",
  //         customClass: {
  //           confirmButton: "custom-green-button",
  //         },
  //       }).then(() => {
  //         if (!response.data.user?.is_cleaner) {
  //           navigate("/login");
  //         } else {
  //           Swal.fire({
  //             icon: "success",
  //             text: "Password Changed! You can return to your app now.",
  //             customClass: {
  //               confirmButton: "custom-green-button",
  //             },
  //           });
  //         }
  //       });
  //     } catch (error) {
  //       Swal.fire({
  //         icon: "error",
  //         text:
  //           error?.response?.data.message ||
  //           error.response?.data?.error ||
  //           "Please give us a moment to fix it. Feel free to try again later",
  //         customClass: {
  //           confirmButton: "custom-red-button",
  //         },
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  // });

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BASE_URL}/api/password-reset/complete/`,
          {
            uidb64,
            token,
            password: values.password,
          }
        );

        // is_cleaner ko state me save karo
        setIsCleaner(response.data.user?.is_cleaner);

        Swal.fire({
          icon: "success",
          text: response.data.message || "Password Changed",
          customClass: {
            confirmButton: "custom-green-button",
          },
        }).then(() => {
          if (!response.data.user?.is_cleaner) {
            navigate("/login");
          }
          // } else {
          //   Swal.fire({
          //     icon: "success",
          //     // text: "Password Changed! You can return to your app now.",
          //     text: response.data.message || "Password Changed",
          //     customClass: {
          //       confirmButton: "custom-green-button",
          //     },
          //   });
          // }
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          text:
            error?.response?.data.message ||
            error.response?.data?.error ||
            "Please give us a moment to fix it. Feel free to try again later",
          customClass: {
            confirmButton: "custom-red-button",
          },
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const passwordValidations = validatePassword(formik.values.password);

  return (
    <div className="flex items-center justify-center w-full h-[100vh]">
      {!isCleaner && (
        <div className="lg:w-1/2 bg-[#FFF5CE] flex flex-col items-center justify-center px-10 py-20 rounded-lg shadow-md">
          <img className=" w-[100px] " src="/images/main-logo-2.png" alt="" />
          <h2 className="text-3xl font-bold mb-3 text-center">New Password</h2>
          <p className="text-center">Enter your New Password</p>

          <form
            onSubmit={formik.handleSubmit}
            className="w-full flex flex-col gap-4"
          >
            {/* Password Field */}
            <div className="relative mt-4">
              <label className="font-normal">New Password</label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter New Password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full p-2 border outline-none h-[50px] px-4 rounded-lg"
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-10 right-4 cursor-pointer"
              >
                {showPassword ? <GoEye /> : <GoEyeClosed />}
              </span>
              {formik.errors.password && formik.touched.password && (
                <p className="text-red-500 text-[12px]">
                  {formik.errors.password}
                </p>
              )}
            </div>

            {/* Password Validation Checklist */}
            <div className="text-sm text-[#000000] font-normal">
              <p>Password must include:</p>
              <ul className="list-disc ">
                {[
                  { label: "At least 8 characters", key: "length" },
                  {
                    label: "At least one uppercase letter (A-Z)",
                    key: "uppercase",
                  },
                  {
                    label: "At least one lowercase letter (a-z)",
                    key: "lowercase",
                  },
                  { label: "At least one number (0-9)", key: "number" },
                  {
                    label: "At least one special character (@#%^&*)",
                    key: "specialChar",
                  },
                  { label: "No spaces", key: "noSpaces" },
                ].map((item) => (
                  <li
                    key={item.key}
                    className={`flex items-center ${
                      passwordValidations[item.key]
                        ? "text-black"
                        : "text-red-500"
                    }`}
                  >
                    {passwordValidations[item.key] ? (
                      <FaCheck className="text-green-500 mr-2" />
                    ) : (
                      <FaTimes className="text-red-500 mr-2" />
                    )}
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>

            {/* Submit Button */}

            <div className="flex justify-center items-center">
              <button
                type="submit"
                disabled={loading}
                onClick={formik.handleSubmit}
                className="w-full h-[50px] bg-[#586989] text-white p-2 rounded font-medium mt-5"
              >
                {loading ? <ButtonLoader4 /> : "Confirm Password"}
              </button>
            </div>
          </form>
        </div>
      )}

      {isCleaner && (
        <div className="lg:w-1/2 bg-[#FFF5CE] flex flex-col items-center justify-center px-10 py-20 rounded-lg shadow-md">
          <h1 className="text-center font-semibold text-[18px]">
            Password Changed! You can return to your app now.
          </h1>
        </div>
      )}
    </div>
  );
};

export default ResetLink;
